import { useEffect, memo } from 'react';
import { countriesWithPhone } from './constants';
import FormSection from '@shared/components/FormSection';
import GenericDropdown from '@shared/components/GenericDropdown';
import StyledTextField from '@shared/components/StyledTextField';

const NoTravelContact = ({ formik }) => {
  useEffect(() => {
    const fieldNames = [
      'name',
      'lastname',
      'codePhone',
      'caracteristicPhone',
      'phone',
    ];
    for (const name of fieldNames) {
      const meta = formik.getFieldMeta(`noViaja.${name}`);
      if (meta.touched && meta.error) {
        const input = document.getElementById(`noViaja-${name}`);
        if (input) {
          setTimeout(() => {
            input.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 50);
        }
        break;
      }
    }
  }, [formik]);

  return (
    <FormSection
      title="Contacto de emergencia"
      customLayout={{
        md: {
          1: 3,
          2: 3,
          3: 2.2,
          4: 1.5,
          5: 2.3,
        },
      }}
    >
      {/* Nombre */}
      <StyledTextField name="noViaja.name" label="Nombre" formik={formik} />

      {/* Apellido */}
      <StyledTextField
        name="noViaja.lastname"
        label="Apellido"
        formik={formik}
      />

      {/* Código de país */}
      <GenericDropdown
        items={countriesWithPhone.map((country, idx) => ({
          id: `noViajaCodePhone-${country.value}-${idx}`,
          value: country.value,
          fragments: [{ text: country.label, bold: false }],
        }))}
        selectedItem={
          formik.values.noViaja.codePhone
            ? {
                id: `selected-${formik.values.noViaja.codePhone}`,
                value: formik.values.noViaja.codePhone,
                fragments: [
                  {
                    text:
                      countriesWithPhone.find(
                        c => c.value === formik.values.noViaja.codePhone
                      )?.label || '',
                    bold: false,
                  },
                ],
              }
            : null
        }
        onSelect={item => formik.setFieldValue('noViaja.codePhone', item.value)}
        buttonLabel="Código"
      />

      {/* Característica */}
      <StyledTextField
        name="noViaja.caracteristicPhone"
        label="Cod. de área"
        formik={formik}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      />

      {/* Teléfono */}
      <StyledTextField
        name="noViaja.phone"
        label="Celular (sin el 15)"
        formik={formik}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      />
    </FormSection>
  );
};

export default memo(NoTravelContact);
